import { render, staticRenderFns } from "./LKPublicationsStorageList.vue?vue&type=template&id=30fc8306&"
import script from "./LKPublicationsStorageList.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsStorageList.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsStorageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSkeletonLoader})
